/**
 * Helper para facilitar o uso de autenticação
 *
 * Este helper abstrai o fluxo de geração de JWT e uso na requisição.
 */

import auth from './auth';

class AuthHelper {
  /**
   * Busca usuário e endereço
   *
   * Fluxo automático:
   * 1. Gera JWT usando CPF (POST /v2/generateCpfJwt)
   * 2. Usa JWT como Bearer Token no header Authorization
   * 3. Faz requisição GET /v2/getUserAndAddressByTaxIdNumberNoSession/{cpf}
   *
   * @param {string} taxIdNumber - CPF/CNPJ do usuário
   * @param {Object} options - Opções (opcional)
   * @param {string} options.bearerToken - Bearer Token customizado (se fornecido, não gera novo JWT)
   * @returns {Promise<Object>} Dados do usuário e endereço
   */
  getUserAndAddressByTaxIdNumberNoSession(taxIdNumber, options = {}) {
    return auth.getUserAndAddressByTaxIdNumberNoSession(taxIdNumber, options);
  }

  /**
   * Gera JWT usando CPF/CNPJ
   *
   * @param {string} taxIdNumber - CPF/CNPJ do usuário
   * @returns {Promise<string>} Bearer Token (JWT)
   */
  generateCpfJwt(taxIdNumber) {
    return auth.generateCpfJwt(taxIdNumber);
  }
}

const instance = new AuthHelper();
export default instance;




// WEBPACK FOOTER //
// ./src/services/auth-helper.js